"use strict";

exports.__esModule = true;
exports["default"] = Video;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Video(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M485.87 80H25.578C11.854 80 1 90.695 1 104.419v303.285C1 421.619 11.854 433 25.578 433H485.87c13.936 0 25.13-11.381 25.13-25.296V104.419C511 90.695 499.806 80 485.87 80zM255.83 393.558c-75.926 0-137.4-61.475-137.4-137.401 0-75.926 61.474-137.399 137.4-137.399 75.907 0 137.401 61.474 137.401 137.399-.001 75.926-61.495 137.401-137.401 137.401zm58.665-127.587l-81.647 48.304c-9.125 5.407-16.848.979-16.848-9.813v-96.609c0-10.792 7.723-15.22 16.848-9.814l81.791 48.305c9.104 5.405 8.962 14.221-.144 19.627z"
  }));
}